import { Lieu } from '../../../../../common/src/entities';

export const afficherLieu = (lieu: Lieu) => {
    return (
        (lieu.name ? lieu.name + ' - ' : '') +
        (lieu.adresse ? lieu.adresse : '') +
        (lieu.ville ? ', ' + lieu.ville : '') +
        (lieu.province ? ', ' + lieu.province : '') +
        (lieu.code_postal ? ', ' + lieu.code_postal : '')
    );
};
